export default __webpack_public_path__ + "static/media/hht2_sitcom_04.01757bb8.png";